export const getRequestUrl = () => {
  const url = new URL(window.location.href);

  url.searchParams.delete('transactionId');
  url.searchParams.delete('with_best_place');

  return url;
};
